import styled from "styled-components";
import { LIGHT_BLUE, NEAR_WHITE } from "../../config";

export const CheckboxContainer = styled.div<{ readOnly?: boolean }>`
  position: relative;
  display: flex;
  user-select: none;
  height: 20px;
  align-items: center;
  margin-bottom: 8px;

  label {
    display: flex;
    align-items: center;
    overflow: hidden;

    .check {
      cursor: ${({ readOnly }) => (readOnly ? "not-allowed" : "pointer")};
      width: 16px;
      height: 16px;
      min-width: 16px;
      min-height: 16px;
      stroke-width: 5px;
      border-radius: 4px;
      border: 2px solid ${NEAR_WHITE};
      transition: 0.15s ease;
      margin-right: 10px;
      path {
        display: none;
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        stroke: ${NEAR_WHITE};
        animation: stroke 0.2s 0.075s ease forwards;
      }
    }
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  display: none;
  :checked + .check {
    background-color: ${LIGHT_BLUE};
    border-color: ${LIGHT_BLUE};
    path {
      display: block;
    }
  }
`;

export const Label = styled.div`
  font-size: 13px;
  color: ${NEAR_WHITE};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
